module.exports = __webpack_public_path__ + "static/media/img-download-center1.ff70b672.png";